// @ts-nocheck
import { OverflowWrapperProps } from "@insite/mobius/Popover/Popover";
import { StyledProp } from "@insite/mobius/utilities/InjectableCss";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

const focusedStyles = (widthToUse: number, isAuthenticated: boolean, isTabbedHeader: boolean) => {
    const baseOffset = isTabbedHeader ? 125 : 0;
    const smallerScreenOffset = isTabbedHeader ? baseOffset - 20 : baseOffset;
    const extraSizeOnSmallerScreens = isTabbedHeader ? 60 : 30;
    const leftOnIpad = isTabbedHeader ? `45%` : `50%`;
    return {
        css: css`
            position: absolute;

            max-width: ${widthToUse}px;

            @media (min-width: 900px) and (max-width: 1350px) {
                left: ${isAuthenticated
                    ? `calc(22% + ${smallerScreenOffset}px)`
                    : `calc(33% + ${smallerScreenOffset}px)`};
                max-width: ${widthToUse}px;
            }
            @media (min-width: 600px) and (max-width: 900px) {
                left: ${leftOnIpad};
                max-width: calc(100% + ${extraSizeOnSmallerScreens}px);
            }

            top: ${pxToRem(22)};
            transform: translate(-50%, -50%);
            width: 500% !important;
            left: calc(33% + ${pxToRem(baseOffset)});
            will-change: transform;
            transition: max-width 0.3s ease, transform 0.3s ease, translate 0.3s ease;
        `,
    };
};

const unfocusedStyles = {
    css: css`
        left: 50%;

        top: ${pxToRem(22)};

        width: 500% !important;
        max-width: 100%;
        transform: translate(-50%, -50%);
        position: absolute;
        transition: max-width 0.3s ease, transform 0.3s ease, translate 0.3s ease;
        will-change: transform;
    `,
};

export const getOverFlowWrapperProps = (
    isFocused: boolean,
    widthToUse: number,
    isAuthenticated: boolean,
    handleBlur: () => void,
    handleFocus: () => void,
    isTabbedHeader: boolean,
    popoverWrapperCss?: StyledProp<{}> | undefined,
): OverflowWrapperProps => {
    const overFlowWrapperStyles = isFocused
        ? focusedStyles(widthToUse, isAuthenticated, isTabbedHeader)
        : unfocusedStyles;

    const overFlowWrapperProps: OverflowWrapperProps = {
        onBlur: handleBlur,
        onFocus: handleFocus,
        css: css`
            ${popoverWrapperCss}

            ${overFlowWrapperStyles.css}
            z-index: 5;
        `,
    };

    return overFlowWrapperProps;
};
